// login page strings. Keys are read as $t('login.<key>').
export default {
  en: {
    pageTitle: 'Login',
    brandSub: 'CS Console',
    title: 'Sign in',
    lead: 'Staff access only. Accounts are created by an administrator.',
    username: 'Username',
    usernamePlaceholder: 'username',
    password: 'Password',
    passwordPlaceholder: 'Password',
    submit: 'Sign in',
  },
  vi: {
    pageTitle: 'Đăng nhập',
    brandSub: 'CS Console',
    title: 'Đăng nhập',
    lead: 'Chỉ dành cho nhân viên. Tài khoản do quản trị viên tạo.',
    username: 'Tên đăng nhập',
    usernamePlaceholder: 'tên đăng nhập',
    password: 'Mật khẩu',
    passwordPlaceholder: 'Mật khẩu',
    submit: 'Đăng nhập',
  },
}
